module.exports = __webpack_public_path__ + "static/media/visitScheduleIcon.d4cb98df.svg";